import { LanguageSelection } from "./LanguageSelection";
import { TrackControls } from "./TrackControls";
import { TrackProgress } from "./TrackProgress";
import { VersionSelection } from "./VersionSelection";

import * as styles from "./styles.module.scss";

export const CurrentTrack = ({
    guide,
    language,
    version,
    track,
    setLanguage,
    setVersion,
}) => {
    const image = track?.image ?? version?.image ?? guide.image;

    return (
        <div className={styles.track}>
            { image ? (
                <div className={styles.image}>
                    <img
                        src={image.source}
                        alt={image.alt ?? ''}
                        width={image.width}
                        height={image.height}
                    />
                </div>
            ) : null }

            <div className={styles.title}>
                {track?.title ?? version?.title ?? language?.title ?? guide?.title}
            </div>

            <div className={styles.progress}>
                <TrackProgress key={track?.number} />
            </div>

            <div className={styles.controls}>
                <TrackControls />
            </div>

            <div className={styles.language}>
                <LanguageSelection
                    guide={guide}
                    language={language}
                    setLanguage={setLanguage}
                />
            </div>

            <div className={styles.version}>
                <VersionSelection
                    language={language}
                    version={version}
                    setVersion={setVersion}
                />
            </div>
        </div>
    );
};
